import { Button, CircularProgress, Typography } from '@material-ui/core';
import Role from 'App/Vehicles/shared/Role';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import useUsers from 'core/hooks/useUsers';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import LinkRow from 'Elements/GridTable/LinkRow';

import { Schema as UserParamsSchema } from './schema';

const Row = styled(GridRow)`
  grid-template-columns: 150px auto;
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

type Props = {
  params: UserParamsSchema;
};

export default function UsersTable({ params }: Props) {
  const { data, loading, hasMore, loadMore } = useUsers(params);

  return (
    <GridTable>
      <Header>
        <Row>
          <Column>Rooli</Column>
          <Column>Nimi</Column>
        </Row>
      </Header>

      <Body>
        {data.map(user => (
          <LinkRow to={'/users/' + user.id} key={user.id}>
            <Row hover>
              <Column>
                <Role id={user.role_id} />
              </Column>
              <Column>{user.full_name}</Column>
            </Row>
          </LinkRow>
        ))}
        <Row>
          <CenterColumn>
            {loading && <CircularProgress />}
            {!loading && hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore}>
                Lataa lisää
              </Button>
            )}
            {!loading && !hasMore && (
              <Typography variant="subtitle1">
                Ei enempää käyttäjiä,{' '}
                <Link to={`/users/create`}>lisää uusi</Link>
              </Typography>
            )}
          </CenterColumn>
        </Row>
      </Body>
    </GridTable>
  );
}
